import React from 'react';
import {connect} from 'react-redux';
import * as s from './selectors';

function ProductPreview({selectedIngredients})  {
    return (
        <div className="customizable-product-view">
            <div className="customizable-product-view__images">
                {selectedIngredients.map((ingredient) => {
                    return <img className="customizable-product-view__ingredient-img" alt={ingredient.label} key={ingredient.id} src={ingredient.image || "https://picsum.photos/500"}/>
                })}
            </div>
        </div>
    );
}

export default connect(
    (state) => ({
        selectedIngredients: s.selectedIngredients(state)
    })
)(ProductPreview);
